import type { ISelfieQuery } from "lib/queries/__generated__/SelfieQuery.generated";
import type { IPlatformVertical } from "types/graphqlTypes";

type Selfie = NonNullable<ISelfieQuery["selfie"]>;

export default function checkCanExportFinancialsData(
  _vertical: IPlatformVertical,
  selfie: Selfie | null | undefined,
): boolean {
  if (selfie?.viewerCanExportFinancialsData) {
    return true;
  }
  return selfie?.isSiteAdmin ?? false;
}
